// extracted by mini-css-extract-plugin
export default {"rangeInput":"index__rangeInput__8zX3f"};